import {
  Avatar,
  Box,
  Button,
  Grid,
  IconButton,
  Typography,
  Chip,
  Dialog,
  DialogContent,
  Card
} from '@mui/material';
import React, { useContext, useEffect, useState } from 'react';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import CloseIcon from '@mui/icons-material/Close';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

import MultipleImageUploadDialog from "../../../components/ImgUpload/MultipleImageUpload";
import { ProviderServices } from '../CrudServices';
import { UserProfileContext } from '../UserProfile';
import { Helpers } from '../../../services/Helpers';
import Swal from 'sweetalert2';
import { useFormContext } from 'react-hook-form';
import GalleryView from '../../../components/ImageViewer/GalleryView';
import { UserDataContext } from './ViewProfile';

const MAX_IMAGES = 15; // Maximum number of images allowed

const PersonalGallery = () => {
  const { personalDetails } = useContext(UserDataContext);

  const [galleryImages, setGalleryImages] = useState([]);
  const [viewerOpen, setViewerOpen] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);

  const imgData = {
    path: "expert-gallery",
    img_type: "single"
  };

  useEffect(() => {
    const initialGallery = (personalDetails?.gallery || []).map(img => ({
      name: img,
      isNew: false
    }));
    setGalleryImages(initialGallery);
  }, [personalDetails?.gallery]);  

  const openViewer = (index) => {
    setActiveIndex(index);
    setViewerOpen(true);
  };

  const closeViewer = () => {
    setViewerOpen(false);
  };


  const getRemainingSlots = () => MAX_IMAGES - galleryImages.length;

  return (
    <Grid item xs={12}>
      <Card>
        <Box sx={{ p: '.5% 2%', border: '2px solid lightGray', bgcolor: 'lightGray' }}>
          <Typography sx={{ fontWeight: '600', fontSize: '.85rem' }}>Image Gallery</Typography>
        </Box>
      {/* Image Viewer Modal */}
      <Dialog open={viewerOpen} maxWidth="md" fullWidth>
        <Box sx={{ p: '.5% 0% .5% 2%', border: '2px solid lightGray', bgcolor: 'lightGray',display:'flex',justifyContent:'space-between',alignItems:'center' }}>
            <Typography sx={{ fontWeight: '600', fontSize: '.85rem' }}>Image Viewer</Typography>
            <IconButton sx={{bgcolor:'#ec0f0f',borderRadius:0,p:0,'&:hover':{bgcolor:'red'}}} onClick={closeViewer}>
                <CloseIcon sx={{color:'#fff'}}/>
            </IconButton>
        </Box>
        {/* <DialogContent sx={{ position: 'relative', p: 1, textAlign: 'center' }}> */}
          <GalleryView images={galleryImages} selectedIndex={activeIndex} baseUrl={`${Helpers.ImagePathUrl()}/expert-gallery`}/>
        {/* </DialogContent> */}
      </Dialog>

      {/* Gallery Header with Image Count */}
        <Box sx={{ mx: 'auto', my: '1%', px: '2%' }}>
          <Typography variant="body2" color="textSecondary" sx={{ mb: 1 }}>
            Images: {galleryImages.length}/{MAX_IMAGES} {getRemainingSlots() > 0 && `(${getRemainingSlots()} slots remaining)`}
          </Typography>
        </Box>

      {/* Image Gallery Grid */}
      <Grid container sx={{ mx: 'auto', my: '1%' }}>
        <Grid item xs={12} sx={{ display: 'flex', gap: '1%', flexWrap: 'wrap', p: '2%' }}>
          {galleryImages.map((item, index) => (
            <Box
              key={item.name}
              sx={{ position: 'relative', width: '10%', mb: '2%', cursor: 'pointer' }}
            >
              <img
                src={`${Helpers.ImagePathUrl()}/expert-gallery/md/${item.name}`}
                alt="expert-gallery"
                style={{ width: 100, height: 100, border: '1px solid lightGray', borderRadius: '1rem' }}
                onClick={() => openViewer(index)}
              />
            </Box>
          ))}
        </Grid>
      </Grid>
    </Card>
    </Grid>
  );
};

export default PersonalGallery;
